/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:auto;display:flex;position:relative}[_nghost-%COMP%] > div[_ngcontent-%COMP%]{position:absolute;top:0;bottom:0;left:0;right:0;display:flex}[_nghost-%COMP%]   .mco-warning[_ngcontent-%COMP%]{background-color:#eee8aa}[_nghost-%COMP%]   .mco-error[_ngcontent-%COMP%]{background-color:#f08080}"];
export { styles as styles };
